import userApi from '../api/userApi'
import userRepo from '../repos/userRepo'

export default {
    /**
     * Fetch User and Access rights from the Server and populate Repo
     */
    async fetchAndStoreUser() {
        // Try and fetch the user from server
        let user = await userApi.getUser();

        // Clear user table
        await userRepo.clearUser();
        await userRepo.clearAccess();

        await userRepo.addUser(user);        

        if(user.Access) {
            user.Access.forEach(async access => {
                await userRepo.addAccess(access);                
            })
        }
    }
}